/**
 * TextFieldWithLabel Component
 */

import * as React from 'react';
import * as BEM from 'react-bem-helper';
import './styles.scss';

import * as classNames from 'classnames';
import TextField, { TextFieldProps } from '../../../atoms/forms/TextField';
import Label, { LabelProps } from '../../../atoms/text/Label';

interface IOwnProps extends TextFieldProps {
  label: string;
  note?: string;
}

export type TextFieldWithLabelProps = IOwnProps;

const classes = new BEM('textfield');

export default class TextFieldWithLabel extends React.Component<IOwnProps, {}> {
  private textfield;

  focus() {
    this.textfield.focus();
  }

  render() {
    const {
      className,
      label,
      note,
      ...fieldProps
    } = this.props;

    const classNameWithLabel = classNames(className, 'textfield--with-label');
    const optional = this.props.optional;
    const name = this.props.input ? this.props.input.name : this.props.name;
    let noteLabel: JSX.Element | null = null;

    if (note || optional != null) {
      const noteProps: LabelProps = {
        size: 'small',
        variant: 'note',
        ...classes('note'),
      };
      noteLabel = <Label {...noteProps}>{note || 'Optional'}</Label>;
    }

    return (
      <TextField ref={(node) => this.textfield = node} className={classNameWithLabel} {...fieldProps}>
        <Label text={label} size="small" htmlFor={name} {...classes('label') } />
        {noteLabel}
        {this.props.children}
      </TextField>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/molecules/forms/TextFieldWithLabel/index.tsx